import Login from "../../components/units/Login/Login";

export default function LoginPage() {
  return <Login />;
}
